import React from "react";

type CustomerRequestProps = {
  note?: string;
};

export const CustomerRequest = ({ note }: CustomerRequestProps) => {
  if (!note) {
    return null;
  }

  return (
    <div className="customerRequests pt-[var(--panelPadding)] flex">
      <div className="customerRequestsLabel font-bold">Special Requests</div>
      <div className="customerRequestsNote pl-1">{note}</div>
    </div>
  );
};
